/** Note & comment contracts — spec §6.6, §6.7, §5-F6, §5-F7. */
import { z } from 'zod';
import { COMMENT_ENTITY_TYPES, NOTE_SCOPES } from './enums.js';
import { objectIdSchema, richTextSchema } from './common.js';
export const createNoteSchema = z
    .object({
    scope: z.enum(NOTE_SCOPES),
    title: z.string().trim().min(1).max(200),
    body: richTextSchema.optional(),
    projectId: objectIdSchema.nullish(),
    taskId: objectIdSchema.nullish(),
    parentNoteId: objectIdSchema.nullish(),
    tags: z.array(z.string().min(1).max(40)).max(20).default([]),
    attendeeIds: z.array(objectIdSchema).max(50).default([]),
    meetingDate: z.coerce.date().nullish(),
    isPinned: z.boolean().default(false),
})
    .strict()
    .superRefine((val, ctx) => {
    if (val.scope === 'project' && !val.projectId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['projectId'],
            message: 'Project notes need a projectId',
        });
    }
    if (val.scope === 'task' && !val.taskId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['taskId'],
            message: 'Task notes need a taskId',
        });
    }
});
export const updateNoteSchema = z
    .object({
    title: z.string().trim().min(1).max(200),
    body: richTextSchema,
    tags: z.array(z.string().min(1).max(40)).max(20),
    attendeeIds: z.array(objectIdSchema).max(50),
    meetingDate: z.coerce.date().nullish(),
    parentNoteId: objectIdSchema.nullish(),
    isPinned: z.boolean(),
})
    .strict()
    .partial();
export const listNotesQuerySchema = z
    .object({
    scope: z.enum(NOTE_SCOPES).optional(),
    projectId: objectIdSchema.optional(),
    taskId: objectIdSchema.optional(),
    q: z.string().max(200).optional(),
    tag: z.string().max(40).optional(),
    parentNoteId: z.string().min(1).optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
})
    .strict();
export const reorderNotesSchema = z
    .object({
    items: z
        .array(z.object({
        noteId: objectIdSchema,
        order: z.number().int().min(0),
        parentNoteId: objectIdSchema.nullish(),
    }))
        .min(1)
        .max(500),
})
    .strict();
export const convertNoteToTaskSchema = z
    .object({
    text: z.string().trim().min(1).max(300),
    projectId: objectIdSchema,
    assigneeId: objectIdSchema.nullish(),
    dueDate: z.coerce.date().nullish(),
    priority: z.enum(['P0', 'P1', 'P2', 'P3']).optional(),
})
    .strict();
/* ── Comments ──────────────────────────────────────────── */
export const createCommentSchema = z
    .object({
    entityType: z.enum(COMMENT_ENTITY_TYPES),
    entityId: objectIdSchema,
    parentCommentId: objectIdSchema.nullish(),
    body: richTextSchema,
    attachmentIds: z.array(objectIdSchema).max(10).default([]),
})
    .strict();
export const updateCommentSchema = z.object({ body: richTextSchema }).strict();
export const reactionSchema = z.object({ emoji: z.string().min(1).max(8) }).strict();
export const listCommentsQuerySchema = z
    .object({
    entityType: z.enum(COMMENT_ENTITY_TYPES),
    entityId: objectIdSchema,
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
})
    .strict();
export const COMMENT_EDIT_WINDOW_HOURS = 24;
//# sourceMappingURL=note.js.map